import {platformedClient} from "..";

export const getCompanyLogo = (key: string, retina: boolean = false): string => {
  const path = retina
    ? `/external_api/media_assets/company_logo/{key}/2x`
    : `/external_api/media_assets/company_logo/{key}`;
  return platformedClient.externalUrl("get", path, {path: {key}});
};

const mediaAssets = {getCompanyLogo};

export default mediaAssets;
